module.exports = __webpack_public_path__ + "img/reading__interior.2d5ae97e.svg";